<template>
  <div>
    <slot></slot>
    <p v-if="items.length === 0">Brak elementów</p>
    <el-button class="add-item-button" type="warning" @click="addItem">
      Dodaj nowy
    </el-button>
  </div>
</template>
<script>
import { clone } from 'lodash'

export default {
  props: {
    blankObject: Object,
    items: Array,
    errors: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addItem() {
      const newObject = clone(this.blankObject)
      if (!Array.isArray(this.items)) {
        this.$emit('input', [newObject])
      } else {
        this.items.push(newObject)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.add-item-button {
  margin-top: 15px;
}
</style>
